import axios from 'axios'
import QueryString from "querystring";
import {APIHOST} from "@/settings";

class AuthService {
    loginByAuthorizationCode(authorizationCode) {
        return axios.post(`${APIHOST}/token`, QueryString.stringify({
            grant_type: "password",
            authorizationCode: authorizationCode
        }));
    }

    getLogin(token) {
        return axios.get(`${APIHOST}/api/Login`, {
            headers: {'Authorization': `Bearer ${token}`}
        });
    }

    systemTermsCheck(accessToken) {
        return axios.get(`${APIHOST}/api/SystemTerms`, {
            headers: {'Authorization': `Bearer ${accessToken}`}
        });
    }
}

export default new AuthService();